import styled from 'styled-components'
import { Flex } from "reflexbox";

export const FlexLayout = styled(Flex)`
  background-color: ${(props) => props.theme.colors.bg};
`
